import {
  Link
} from "./chunk-4AJIRXP6.js";
import "./chunk-BG6MEPCE.js";
export {
  Link as SafeLink,
  Link as default
};
